// The renderer the tests use: one GLStage plus the tumbling-E stimulus. New stimuli ported
// from visualTools implement `Stimulus` (glStage.ts) and draw through `renderer.stage`.

import { GLStage, type StageInfo, type Stimulus } from "./glStage";
import { letterOrigin, tumblingE, type EFrame } from "./stimuli/tumblingE";

export type { EFrame } from "./stimuli/tumblingE";
export { eMask } from "./stimuli/tumblingE";
export type RendererInfo = StageInfo;

export class ERenderer {
  readonly stage: GLStage;

  constructor(readonly canvas: HTMLCanvasElement, opts: { preferFloat16?: boolean } = {}) {
    this.stage = new GLStage(canvas, opts);
  }

  get gl(): WebGL2RenderingContext { return this.stage.gl; }
  get info(): StageInfo { return this.stage.info; }

  resize(widthPx: number, heightPx: number): void {
    this.stage.resize(widthPx, heightPx);
  }

  letterOrigin(strokePx: number): [number, number] {
    return letterOrigin(this.stage, strokePx);
  }

  draw(f: EFrame, outputBits = this.stage.defaultOutputBits): void {
    tumblingE.draw(this.stage, f, { outputBits, frameIndex: this.stage.nextFrameIndex() });
  }

  /** Draw any other stimulus on the same stage. */
  drawStimulus<P>(s: Stimulus<P>, params: P, outputBits = this.stage.defaultOutputBits): void {
    s.draw(this.stage, params, { outputBits, frameIndex: this.stage.nextFrameIndex() });
  }

  readPixel(x: number, y: number): [number, number, number, number] {
    return this.stage.readPixel(x, y);
  }
}
